export default __webpack_public_path__ + "static/media/nbt.c7bfd781.jsworker";